import { Link } from 'react-router-dom';
import React from 'react';
import './email-subject.scss';
export interface EmailSubjectProps {
  detailsRoute?: string;
  subject?: string;
  isDesignIteration1Enabled?: boolean;
}
export const EmailSubject = ({ detailsRoute, subject, isDesignIteration1Enabled = false }: EmailSubjectProps) => {
  return (
    <td className={`email-subject-cell ${isDesignIteration1Enabled ? 'email-subject-cell-v2' : ''}`}>
      <div>
        <Link
          to={detailsRoute}
          data-testid="email-link"
          onClick={(e) => e.stopPropagation()}
          title={isDesignIteration1Enabled ? subject : undefined}
        >
          {subject}
        </Link>
      </div>
    </td>
  );
};
